import { CommonLoading } from 'react-loadingg';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import Tglogo from '../../images/top-glove.png';
import SearchUserByEC from '../SearchUserByEC/SearchUserEC';


const HodCommentForm = (props) => {
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const { REACT_APP_API_BACKEND_URL, REACT_APP_API_BACKEND_URL_EXIT_FORM } = process.env;
    const [applicantUserName, setApplicantUserName] = useState();
    const [applicantID, setApplicantID] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [name, setName] = useState('');
    const [username, setUsername] = useState(''); //usernameHOD not username Staff
    const [usernameHRSS, setUsernameHRSS] = useState('');
    const [userPosition, setUserPosition] = useState('');
    const [isSuperiorBadgeid, setSuperiorBadgeId] = useState('');

    const history = useHistory();

    // !=== Check user permission
    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Resignation') &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            }
            else {
                setIsLoading(false);
            }
        }

    }, [props.loginList]);

    useEffect(() => {
        if (!location.state) {
            window.stop();
            alert('Please access this page by selecting a user from the resignation list');
            window.location = '/resignation';
        }
        else {
            setApplicantUserName(location.state.rowData.userIDName);
            setApplicantID(location.state.rowData.userID);
        }
    }, [location]);

    // !=== Fetch resigned staff's details
    useEffect(() => {
        if (applicantUserName) {
            getResignApplicantDetailwithUserName();
        }
    }, [applicantUserName]);

    const getSuperiorDetails = (userProp) => {
        if (userProp) {
            setName(userProp.label);
            setUsername(userProp.username);
            setUserPosition(userProp.title);
            setSuperiorBadgeId(userProp.userId)
            console.log(userProp)
        }
        else {
            setName('');
            setUsername('');
            setUserPosition('');
        }
    }
    const getUsernameHRSS = (userProp) => {
        console.log(userProp)
        if (userProp) {
            setUsernameHRSS(userProp.username);
        }
        else {
            setUsernameHRSS("");
        }
    }

    useEffect(() => {
        console.log('Full Name:', location.state.rowData.userName);
        console.log('BadgeID:', location.state.rowData.userID);
        console.log('Join Date:', location.state.rowData.joinDate);
        console.log('Factory:', location.state.rowData.userFactory);
        console.log('Department:', location.state.rowData.userDept);
        console.log('Position:', location.state.rowData.positionUser);
        console.log('Job Grade:', location.state.rowData.userJobGrade);
    }, [location.state.rowData.userName, location.state.rowData.userID, location.state.rowData.joinDate, location.state.rowData.userFactory, location.state.rowData.userDept, location.state.rowData.positionUser, location.state.rowData.userJobGrade]);

    // !=== Get User Details by Username
    async function getResignApplicantDetailwithUserName() {
        if (applicantUserName) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getResignApplicantDetail';
            axios
                .post(url, { badgeID: applicantUserName })
                .then((response) => {
                    if (response.data.status === 0) {
                        getResignApplicantDetailwithBadgeID()
                    }

                },
                )
                .catch((err) => console.error(err));

        }


    }

    // !=== Get User Details by Badge ID
    async function getResignApplicantDetailwithBadgeID() {
        console.log("applicantUserName = "+ applicantUserName)
        if (applicantUserName) {
            const url =
                REACT_APP_API_BACKEND_URL + '/api/resignation/getResignApplicantDetail';
            axios
                .post(url, { badgeID: applicantID })
                .then((response) => {
                    if (response.data.status === 0) {
                        alert("There contain no data on this user. Please contact IT regarding this issue.")
                        history.push('/resignation');
                        window.location.reload();
                    }
                    else {

                    }
                })
                .catch((err) => console.error(err));
        }
    }
    async function handleFormSubmit(e) {
        e.preventDefault(); // Prevent default form submission

        if (!usernameHRSS) {
            alert('Requestor name can\'t be empty');
            return; // Stop execution if usernameHRSS is empty
        }

        const form = e.target;
        const isConfirmed = window.confirm('Are you sure you want to save the data?');

        if (location.state.rowData.hodUsername !== username) {
            setIsLoading(true);

            const urlChangeSuperior = REACT_APP_API_BACKEND_URL_EXIT_FORM+ `change/hod/pic?userBadgeId=${location.state.rowData.userID}&newHodUsername=${username}`;
            try {
                await axios.put(urlChangeSuperior, null, {
                    headers: {
                        "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    },
                });
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    alert('There is a same superior name in the system. Please verify the data and try again.');
                } else {
                    console.error('An unexpected error occurred:', error);
                }
            } finally {
                setIsLoading(false);
            }
        }

        if (form.checkValidity() && isConfirmed && (location.state.rowData.formActionHOD === null || location.state.rowData.formActionHOD === undefined || location.state.rowData.formActionHOD === '')) {
            setIsLoading(true);
            setIsSubmitting(true);
            const formData = new FormData(form);
            const updatedValue = {
                lastPerformance: formData.get('last_performance'),
                periodFrom: formData.get('period_from'),
                periodTo: formData.get('period_to'),
                bmi: Number(formData.get('bmi')),
                medicalCert: Number(formData.get('mc')),
                unpaidLeave: Number(formData.get('upl')),
                hospLeave: Number(formData.get('hosp')),
                emergencyLeave: Number(formData.get('el')),
                absenteeism: Number(formData.get('abs')),
                warningLetter: Number(formData.get('wl')),
                rewardLetter: Number(formData.get('rw')),
                suggestion: formData.get('sg'),
                trainingLetter: Number(formData.get('tl')),
                reminderLetter: Number(formData.get('rl')),
                requestBy: formData.get('requestBy'),
                requestorName: usernameHRSS,
            }

            const url = REACT_APP_API_BACKEND_URL_EXIT_FORM +`add/hod/comment/form?userBadgeId=${location.state.rowData.userID}`;
            try {
                const response = await axios.post(url, updatedValue, {
                    headers: {
                        "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    },
                });
                if (response) {
                    alert('HOD Comment form details saved successfully!');
                    history.push('/resignation');
                    window.location.reload();
                }
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    alert('There is a duplicate record in the system. Please verify the data and try again.');
                } else {
                    console.error('An unexpected error occurred:', error);
                }
            } finally {
                setIsSubmitting(false);
            }
            // console.log(inputValue);
        }
        else if (location.state.rowData.formActionHOD && isConfirmed) {
            setIsLoading(true);
            setIsSubmitting(true);
            const formData = new FormData(form);
            const updatedValue = {
                userBadgeId: location.state.rowData.userID,
                lastPerformance: formData.get('last_performance'),
                periodFrom: formData.get('period_from'),
                periodTo: formData.get('period_to'),
                bmi: Number(formData.get('bmi')),
                medicalCert: Number(formData.get('mc')),
                unpaidLeave: Number(formData.get('upl')),
                hospLeave: Number(formData.get('hosp')),
                emergencyLeave: Number(formData.get('el')),
                absenteeism: Number(formData.get('abs')),
                warningLetter: Number(formData.get('wl')),
                rewardLetter: Number(formData.get('rw')),
                suggestion: formData.get('sg'),
                trainingLetter: Number(formData.get('tl')),
                reminderLetter: Number(formData.get('rl')),
                requestBy: formData.get('requestBy'),
                requestorName: usernameHRSS,
            }


            const url = REACT_APP_API_BACKEND_URL_EXIT_FORM+`update/attendance/disciplinary/record`;

            try {
                const response = await axios.put(url, updatedValue, {
                    headers: {
                        "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                    },
                });
                if (response) {
                    alert('HOD Comment form details updated successfully!');
                    history.push('/resignation');
                    window.location.reload();
                }
                if (location.state.rowData.hodUsername !== username) {

                    const urlChangeSuperior = REACT_APP_API_BACKEND_URL_EXIT_FORM +`change/hod/pic?userBadgeId=${location.state.rowData.userID}&newHodUsername=${username}`;
                    try {
                        await axios.put(urlChangeSuperior, null, {
                            headers: {
                                "Authorization": `Bearer ${props.cognitoToken.idToken.jwtToken}`,
                            },
                        });
                    } catch (error) {
                        if (error.response && error.response.status === 409) {
                            alert('There is a same superior name in the system. Please verify the data and try again.');
                        } else {
                            console.error('An unexpected error occurred:', error);
                        }
                    }
                }
            } catch (error) {
                console.error('An unexpected error occurred:', error);

            } finally {
                setIsLoading(false);
                setIsSubmitting(false);
            }


        }

        else {
            console.log('Form is invalid');
        }
    }

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container-fluid'
                            }`}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '20px' }}>
                            <div>
                                <img style={{ width: '170px', height: '60px' }} src={Tglogo} />
                            </div>

                            <div style={{ textTransform: 'capitalize', margin: '10px', fontWeight: 'bolder' }}>TOP GLOVE GROUP OF COMPANIES <br />
                                COMMENT FROM SUPERIOR ON RESIGN STAFF

                            </div>
                        </div>
                        <div style={{ fontWeight: 'bolder', textDecoration: "underline", paddingBottom: '10px' }}>Resigned Staff Information </div>
                        <div className='row resignationbg'>
                            <div className='row'>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Full Name (as per NRIC)</div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} defaultValue={location.state.rowData.userName} readOnly required />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Badge ID/User ID</div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' defaultValue={location.state.rowData.userID} readOnly required />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Join Date </div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} defaultValue={location.state.rowData.joinDate} readOnly />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Factory</div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' defaultValue={location.state.rowData.userFactory} readOnly />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Department </div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} defaultValue={location.state.rowData.userDept} readOnly />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Position</div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' defaultValue={location.state.rowData.positionUser} readOnly />
                                </div>
                                <div className='col-sm-2 mb-4 resignationlabeldesign'>Job Grade </div>
                                <div className='col-sm-4 mb-4'>
                                    <span className='resignationdoublecolonspacing'>:</span><input type="text" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} defaultValue={location.state.rowData.userJobGrade} readOnly />
                                </div>
                            </div>
                            {(location.state.rowData.formActionHOD !== undefined) ? (
                                <>
                                    <div className='row' style={{ paddingBottom: '25px' }}>
                                        <div className='col-sm-2 mb-4 resignationlabeldesign'>Superior Username</div>
                                        <div className='col-sm-4 mb-4'>
                                            <span className='resignationdoublecolonspacing'>:</span>
                                            <SearchUserByEC
                                                getSuperiorDetails={getSuperiorDetails}
                                                token={props.cognitoToken.idToken.jwtToken}
                                                hodUsername={location.state.rowData.hodUsername}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-2 mb-4 resignationlabeldesign'>Superior Position</div>
                                        <div className='col-sm-4 mb-4'>
                                            <span className='resignationdoublecolonspacing'>:</span>
                                            <input
                                                type="text"
                                                className='resignationinputdesign'
                                                style={{ textTransform: 'capitalize' }}
                                                value={userPosition}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                ""
                            )

                            }
                        </div>
                        <form onSubmit={handleFormSubmit}>
                            <div style={{ fontWeight: 'bolder', textDecoration: "underline", paddingBottom: '10px', paddingTop: '10px' }}>Attendance Record & Disciplinary Score</div>
                            <div className='row resignationbg'>
                                <div className='row' >
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Last Performance</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input type="text" name="last_performance" className='resignationinputdesign' style={{ textTransform: 'capitalize' }} defaultValue={location.state.rowData.lastPerformance} required />
                                    </div>
                                </div>
                                <div className='row' style={{ paddingBottom: '25px' }}>

                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Period From </div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="period_from" type="date" className='resignationinputdesign' defaultValue={location.state.rowData.periodFrom} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Period To</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="period_to" type="date" className='resignationinputdesign' defaultValue={location.state.rowData.periodTo} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>BMI</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="bmi" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.bmi} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Medical Certificate (MC)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="mc" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.medicalCert} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Unpaid Leave (UPL)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="upl" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.unpaidLeave} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Hospitalization Leave (HOSP)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="hosp" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.hospLeave} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Emergency Leave (EL)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="el" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.emergencyLeave} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Absenteeism (ABS)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="abs" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.absenteeism} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Warning Letter (WL)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="wl" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.warningLetter} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Reward Letter (RW)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="rw" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.rewardLetter} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Suggestion (SG)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="sg" type="text" className='resignationinputdesign' defaultValue={location.state.rowData.suggestion == null ? "0" : location.state.rowData.suggestion} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Training Letter (TL)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="tl" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.trainingLetter} style={{ textTransform: 'capitalize' }} required />
                                    </div>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign'>Reminder Letter (RL)</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input name="rl" type="number" step="0.01" pattern="^\d+(\.\d{1,2})?$" className='resignationinputdesign' defaultValue={location.state.rowData.reminderLetter} style={{ textTransform: 'capitalize' }} required />
                                    </div>

                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign' >Request Date:</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span><input type="date" name="requestBy" className='resignationinputdesign' defaultValue={location.state.rowData.requestBy} required />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-2 mb-4 resignationlabeldesign' >Requestor Name</div>
                                    <div className='col-sm-4 mb-4'>
                                        <span className='resignationdoublecolonspacing'>:</span>
                                        <SearchUserByEC
                                            getSuperiorDetails={getUsernameHRSS}
                                            token={props.cognitoToken.idToken.jwtToken}
                                            hodUsername={location.state.rowData.requestorUsername}

                                            style={{ textTransform: 'capitalize' }} required />
                                    </div>

                                </div>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>


                        </form>

                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default HodCommentForm;